import { render, staticRenderFns } from "./FlebogrifPage.vue?vue&type=template&id=28e1658c&scoped=true"
import script from "./FlebogrifPage.vue?vue&type=script&lang=js"
export * from "./FlebogrifPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1658c",
  null
  
)

export default component.exports